import { useEffect } from 'react';

/**
 * Custom hook to set the document title
 * Format: "{title} - Ägile Ässets by OVERW8"
 */
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - Ägile Ässets by OVERW8` : 'Ägile Ässets by OVERW8';

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
